import React, { useState } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment-timezone";
import Axios from "axios";
import { Form, Button } from "react-bootstrap";

import { useSite } from "../../util/sites";

import "./general-comp.css";
import GYAxios from "../../util/GYAxios";
import EmptyPage from "./EmptyPage";

function DataDownload(props) {
	const currentSites = useSite();
	const [period, setPeriod] = useState({
		fromDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
		toDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
	});
	const customBtnStyle = {
		marginBottom: "5px",
		width: "40%",
	};

	/**
	 * Format date
	 * @param {Date to be formatted} date
	 */
	const formatDate = (date) => moment(date).format("MMMM DD, YYYY");

	/**
	 * Download data of site based on period selected
	 * @param {Selected Site} selectedSite
	 * @param {Period of data to download} period
	 */
	const downloadData = (selectedSite, period) => {
		const table_name = selectedSite.value.table_name;

		GYAxios.post("/general_info/get_columns", {
			table_name,
		}).then((res_cols) => {
			const rowLen = res_cols.data.length;

			let colsStr = "";
			res_cols.data.map((rows, i) => {
				if (rowLen === i + 1) {
					colsStr += '"' + rows.Field + '"\r\n';
				} else {
					colsStr += '"' + rows.Field + '",';
				}
			});

			const fromDate = period.fromDate;
			const toDate = period.toDate;
			const p10URI = `/p10/site/${table_name}/period/${fromDate}/${toDate}`;

			GYAxios.get(p10URI).then((res) => {
				if (res.data != null) {
					res.data = res.data.reverse();
					res.data.map((row) => {
						const values = Object.values(row);
						values[1] = moment(values[1]).format("MM/DD/YY HH:mm");
						let valuesStr = values.join(",") + "\r\n";

						colsStr += valuesStr;
					});

					// Generate a file name
					const fileName = "Instant_Powers_P10_" + table_name;
					//this will remove the blank-spaces from the title and replace it with an underscore

					//Initialize file format you want csv or xls
					const xslData = new Blob([colsStr], {
						type: "data:text/csv;charset=utf-8",
					});

					const uri = URL.createObjectURL(xslData);

					// Now the little tricky part.
					// you can use either>> window.open(uri);
					// but this will not work in some browsers
					// or you will not get the correct file extension

					//this trick will generate a temp <a /> tag
					let link = document.createElement("a");
					link.href = uri;

					//set the visibility hidden so it will not effect on your web-layout
					link.style = "visibility:hidden";
					link.download = fileName + ".csv";

					//this part will append the anchor tag and remove it after automatic click
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				} else {
				}
			});
		});
	};

	/**
	 * Handle date change event
	 * @param {event} event
	 * @param {Date picker} picker
	 */
	const handleEvent = (event, picker) => {
		const additionalBtn = props.additionalBtn;
		const duration_obj = {
			fromDate: picker.startDate.format("YYYY-MM-DD"),
			toDate: picker.endDate.format("YYYY-MM-DD"),
		};
		setPeriod(duration_obj);

		if (additionalBtn != null) additionalBtn.func.setPeriod(duration_obj);
	};

	return (
		<>
			{props.selectedSite != null &&
			props.selectedSite.label != currentSites.defaultSelect.label ? (
				<div className="well downloadSection">
					<h5 id="siteName">Site : {props.selectedSite.label}</h5>
					<h5>Select a Date Range</h5>
					<DateRangePicker
						onApply={(event, picker) => {
							handleEvent(event, picker);
						}}
						ranges={{
							Today: [moment(), moment()],
							Yesterday: [
								moment().subtract(1, "days"),
								moment().subtract(1, "days"),
							],
							"Last 7 Days": [moment().subtract(6, "days"), moment()],
							"Last 30 Days": [moment().subtract(29, "days"), moment()],
							"This Month": [
								moment().startOf("month"),
								moment().endOf("month"),
							],
							"Last Month": [
								moment().subtract(1, "month").startOf("month"),
								moment().subtract(1, "month").endOf("month"),
							],
						}}
						alwaysShowCalendars
						autoApply
					>
						<Form>
							<Form.Group controlId="downloadDRP">
								<Form.Control
									type="text"
									placeholder="Select a date range"
									readOnly
									value={
										period != null
											? `${formatDate(period.fromDate)} - ${formatDate(
													period.toDate,
												)}`
											: "Select a date range"
									}
									style={{ textAlign: "center", backgroundColor: "white" }}
								/>
							</Form.Group>
						</Form>
					</DateRangePicker>
					<Button
						type="submit"
						className="btn btn-success centralised"
						style={customBtnStyle}
						onClick={() => {
							downloadData(props.selectedSite, period);
						}}
					>
						Download P10 datas
					</Button>
					{props.additionalBtn != null && (
						<Button
							type="submit"
							style={customBtnStyle}
							className="btn btn-success centralised"
							onClick={() => {
								const additionalBtn = props.additionalBtn;
								const isHidden = additionalBtn.state.deliveredIsHidden;

								additionalBtn.func.setDeliveredIsHidden(!isHidden);
							}}
						>
							{props.additionalBtn.label}
						</Button>
					)}
				</div>
			) : (
				<EmptyPage message={"No site selected"} />
			)}
		</>
	);
}

export default DataDownload;
